module.exports = __webpack_public_path__ + "static/media/wodkan.d7075075.svg";